module.exports = __webpack_public_path__ + "cab674f7ea4b45dada4fbc7db3f5ba64.svg";